module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#play",
      toString: function () {
        return this.url;
      }
    }